import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { api } from '../../api'
import { localConfig } from '../../../Configs/localConfig'

interface PropsPostCalcarioPropriedade {
  calcarios: number[]
  calcarios_remover: number[]
  cod_propriedade: number
  calcario_padrao: number
  refresh: Function
}

export const usePostCadastroCalcarioPropriedade = (): {
  carregando_salvar_calcarioPropriedade: boolean
  mutate_calcarioPropriedade: (params: PropsPostCalcarioPropriedade) => void
  isSuccess_calcarioPropriedade: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostCalcarioPropriedade> = useMutation(
    async (params: PropsPostCalcarioPropriedade) => {
      const { calcarios, calcarios_remover, cod_propriedade, calcario_padrao, refresh } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(
          `/calcario-propriedade?codConta=${localConfig()?.conta}&codCliente=${
            localConfig()?.codCliente
          }`,
          {
            calcarios: calcarios,
            calcarios_remover: calcarios_remover,
            cod_propriedade: cod_propriedade,
            calcario_padrao: calcario_padrao,
          }
        )
        .then((response: any) => {
          successAlert('Calcário cadastrado com sucesso!', 5000, 'loading')
          refresh()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar calcário!', 5000, 'loading')
            })
          } else {
            errorAlert(
              error.response.data.error ?? 'Falha ao salvar calcário!',
              5000,
              'loading'
            )
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_calcarioPropriedade: mutation.isLoading,
    mutate_calcarioPropriedade: mutation.mutate,
    isSuccess_calcarioPropriedade: mutation.isSuccess,
  }
}